import { render, staticRenderFns } from "./jczs.vue?vue&type=template&id=54313480&scoped=true&"
import script from "./jczs.vue?vue&type=script&lang=js&"
export * from "./jczs.vue?vue&type=script&lang=js&"
import style0 from "./jczs.vue?vue&type=style&index=0&id=54313480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54313480",
  null
  
)

export default component.exports